// Hero banner: a per-language photo (with its own marketing copy baked in) instead of the flat
// gradient. Languages without a dedicated asset keep the plain gradient + our own text overlay.
const HERO_IMAGE_BY_LANG = {
  lv: "header_lv_cel.png",
  ru: "header_ru_cel.png",
  en: "header_en_cel.png",
};

// These photos live under the "default" tenant folder in the bucket (confirmed from a live
// URL), not under REACT_APP_TENANT_NAME ("celotleti") like the rest of this tenant's assets.
function buildHeroImageUrl(file) {
  return (
    `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
    `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/static/default/en/assets/images/${file}`
  );
}

export function getHeroImageUrl(currentLanguage) {
  const file = HERO_IMAGE_BY_LANG[currentLanguage];
  return file ? buildHeroImageUrl(file) : null;
}
